export default __webpack_public_path__ + "static/media/4.116d95cd.png";